import { render, staticRenderFns } from "./AdminEditAppOffers.vue?vue&type=template&id=85fa4f92"
import script from "./AdminEditAppOffers.vue?vue&type=script&lang=ts"
export * from "./AdminEditAppOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports